import styled from 'styled-components';
import { Text } from 'styles/elements/text';

export const ButtonText = styled(Text)`;
  margin: 0;
`;
